<template>
  <q-page-container>
    <q-page class="">
      <div class="title-page">Dados da solicitação</div>
      <section class="section-service col-12">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[
            { label: 'Tab-1', value: 'tab-1' },
            { label: 'Tab-2', value: 'tab-2' },
          ]"
        />
        <q-tab-panels
          v-model="panel"
          class="panel-services"
        >
          <q-tab-panel
            class="panel-item"
            name="tab-1"
          >
            <q-form ref="formtab1">
              <div class="group-input col-12 row q-mt-sm"  v-if="numericalTypeOs == IMEDIATAR_OS_MANUTENCAO || numericalTypeOs === VISITA_TECNICA_2">
            <label for="os_number">{{ numericalTypeOs === VISITA_TECNICA_2 ? 'Nº da OS Atendimento' : 'Nº da OS' }}</label>
            <q-input
              id="os_number"
              ref="osNumberRef"
              v-model="requestData.osNumber"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="10"
              color="red-9"
              dense
              outlined
              mask="##########"
              unmasked-value
              placeholder="0000000000"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>
              <div class="group-input col-12 row q-mt-sm" v-if=" numericalTypeOs === VISITA_TECNICA_2 ">
                <label for="type-os">Tipo de OS Atendimento</label>
                <q-select
                  id="type-os-attendance"
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  dense
                  ref="typeOSAttendanceRef"
                  v-model="requestData.typeOsForAttendance"
                  color="red-9"
                  @filter="filterTypeOsByName"
                  use-input
                  hide-selected
                  fill-input
                  emit-value
                  map-options
                  input-debounce="0"
                  :options="attendanceOptions"
                  option-value="value"
                  option-label="text"
                  bg-color="white"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                  @update:model-value="onAttendanceOsTypeChange"
                />
              </div>
              <div class="group-input col-12 row q-mt-sm" v-else>
                <label for="type-os">Tipo de OS</label>
                <q-select
                  id="type-os"
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  dense
                  ref="typeOSRef"
                  v-model="requestData.typeOS"
                  color="red-9"
                  @filter="getTypeOsByClassification"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="0"
                  :options="optionsTypeOS"
                  option-value="value"
                  option-label="text"
                  bg-color="white"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <div class="group-input col-12 row q-mt-sm" v-if="numericalTypeOs === VISITA_TECNICA_2">
                <label for="type-os">Tipo de OS Geração</label>
                <q-select
                  id="type-os"
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  dense
                  ref="typeOSRef"
                  v-model="requestData.typeOS"
                  color="red-9"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="0"
                  :options="listGenerateOs"
                  option-value="value"
                  option-label="text"
                  bg-color="white"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>

              <div class="group-input col-12 column q-mt-lg"  v-if="numericalTypeOs !== IMEDIATAR_OS_MANUTENCAO">
                <label for="write-off-code">Tipo de agendamento</label>
                <div class="flex row justify-around">
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    val="Realizar agendamento"
                    size="lg"
                    label="Realizar agendamento"
                    color="red-6"
                    :disable="!isEnableScheduling.includes(typeOs)"
                  />
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    val="Abertura imediata"
                    size="lg"
                    label="Abertura imediata"
                    color="red-6"
                    :disable="!isEnableScheduling.includes(typeOs)"
                  />
                </div>
              </div>

              <div
                class="column"
                v-if="requestData.movimentscheduling == schedulingTypes['schedule']"
              >
                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Opção 1</label>
                  <div
                    class="group-input col-12 row q-mt-sm flex justify-around"
                  >
                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.option1"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.date"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />

                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.hourOption1"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.hour"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />
                  </div>
                </div>

                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Opção 2</label>
                  <div
                    class="group-input col-12 row q-mt-sm flex justify-around"
                  >
                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.option2"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.date"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />

                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.hourOption2"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.hour"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />
                  </div>
                </div>
              </div>

              <div class="column" v-if="numericalTypeOs === VISITA_TECNICA_2">
                <div class="group-input col-12 row q-mt-sm">
                  <label for="os_action">Ação</label>
                  <q-select
                    id="os_action"
                    class="col-12 q-mt-sm form-tabulacao"
                    outlined
                    dense
                    disable
                    ref="osActionRef"
                    v-model="requestData.action"
                    emit-value
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="optionsActionOs"
                    @update:model-value=""
                    map-options
                    option-value="id_acao"
                    option-label="desc_acao"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Estado</label>
                  <q-select
                    disable
                    id="state-os"
                    class="col-12 q-mt-sm form-tabulacao"
                    outlined
                    dense
                    ref="stateOSRef"
                    v-model="requestData.state"
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="optionsStateEquipaments"
                    emit-value
                    map-options
                    option-value="id_estado_equipamento"
                    option-label="desc_estado_equipamento"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
                <div class="group-input col-12 row q-mt-lg">
                  <label for="write-off-code">Código de Baixa</label>
                  <q-select
                    id="write-off-code"
                    class="col-12 q-mt-sm"
                    outlined
                    dense
                    ref="writeOffCodeRef"
                    v-model="requestData.writeOffCode"
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="listWriteOffCode"
                    option-value="value"
                    option-label="text"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
              </div>
              <div
                  class="group-input col-12 row q-mt-sm"
                  v-if="typeOs == '9'"
                >
                  <label for="type-os"
                    >Qual a quantidade de OS Troca de Equipamento Streaming
                    deverá ser gerada?</label
                  >
                  <q-select
                    id="type-os"
                    class="col-12 q-mt-sm"
                    outlined
                    dense
                    ref="eqtoAmount"
                    v-model="requestData.osQuantity"
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="eqtoStreamingAmount"
                    option-value="value"
                    option-label="text"
                    bg-color="white"
                    lazy-rules
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    @update:model-value="
                      (val) => (requestData.osQuantity = val?.value || null)
                    "
                  />
                </div>

              <div class="group-input col-12 row q-mt-md">
                <label for="observation">Observação</label>
                <div class="col-12 row flex justify-around">
                  <q-input
                    v-model="requestData.observation"
                    class="col-12 q-mt-sm"
                    bg-color="white"
                    color="red-9"
                    maxlength="120"
                    outlined
                    autogrow
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                    placeholder="Digite até 120 caracteres..."
                  />
                </div>
              </div> </q-form
          ></q-tab-panel>
          <q-tab-panel
            name="tab-2"
            class="col-12 row items-center justify-center"
          >
            <q-form ref="formtab2">
              <div class="group-input col-12 row q-mt-sm" v-if="numericalTypeOs === VISITA_TECNICA_2">
                <label for="os_install_number"
                  >Número equipamento instalado (entrega)</label
                >
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.equipamentNumberInstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="20"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                  @blur="
                    openDialogEquipament(
                      'Confirma numeração do equipamento instalado?'
                    )
                  "
                />
              </div>

              <div class="group-input col-12 row q-mt-sm">
                <label for="os_install_number"
                  >Número equipamento desinstalado</label
                >
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.equipamentNumberUninstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="20"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                  @blur="
                    openDialogEquipament(
                      'Confirma numeração do equipamento desinstalado?'
                    )
                  "
                />
              </div>

              <div class="group-input col-12 row q-mt-md" v-if="numericalTypeOs === VISITA_TECNICA_2">
                <label for="type-os"
                  >Foi necessário trocar o Smart Card?</label
                >
                <div class="col-12 row flex justify-around">
                  <q-radio
                    keep-color
                    v-model="requestData.IsDecoderComum"
                    :val="1"
                    size="lg"
                    label="Sim"
                    color="red-6"
                  />
                  <q-radio
                    keep-color
                    v-model="requestData.IsDecoderComum"
                    :val="0"
                    size="lg"
                    label="Não"
                    color="red-6"
                  />
                </div>
              </div>
               <div
                class="group-input col-12 row q-mt-sm"
                v-if="requestData.IsDecoderComum == 1 && numericalTypeOs === VISITA_TECNICA_2"
              >
                <label for="os_number"
                  >Informe o número do SMARTCARD instalado</label
                >
                <q-input
                  id="os_number"
                  ref="cardNumberRef"
                  v-model="requestData.cardNumberInstaled"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="12"
                  color="red-9"
                  dense
                  outlined
                  unmasked-value
                  type="text"
                  placeholder="0000000000"
                  lazy-rules
                  :rules="[
                    (val) =>
                      !!val ||
                      requestData.IsDecoderComum == 1 ||
                      'Campo Obrigatório',
                  ]"
                />
                <!-- -->
              </div>
              <div
                class="group-input col-12 row q-mt-sm"
                v-if="
                  requestData.IsDecoderComum == 1"
              >
                <label for="os_number"
                  >Informe o número do SMARTCARD desinstalado</label
                >
                <q-input
                  id="os_number"
                  ref="cardNumberRef"
                  v-model="requestData.cardNumberUninstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="12"
                  color="red-9"
                  dense
                  outlined
                  unmasked-value
                  type="text"
                  placeholder="0000000000"
                  lazy-rules
                  :rules="[
                    (val) =>
                      !!val ||
                      requestData.IsDecoderComum == 1 ||
                      'Campo Obrigatório',
                  ]"
                />
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>

        <div>
          <q-footer elevated>
            <q-toolbar elevated>
              <div
                class="flex col-12 row items-center justify-between"
                v-if="isShowProgessBar()"
              >
                <div
                  class="col-8 div-progress q-pa-sm justify-center flex items-center"
                >
                  <q-linear-progress
                    size="md"
                    :value="progressBar"
                    color="red-9"
                    rounded
                  />
                </div>
                <div
                  class="col-2 div-btn-next justify-center flex items-center"
                >
                  <q-btn
                    round
                    color="red-9"
                    @click="addValueBarProgressAndAlterTab"
                    icon="arrow_forward"
                  />
                </div>
              </div>
              <div
                class="flex col-12 row items-center justify-between"
                v-else
              >
                <div
                  class="col-12 justify-between flex items-center div-progress"
                >
                  <q-btn
                    outline
                    unelevated
                    rounded
                    color="red-9"
                    @click="$emit('removeEdit')"
                    label="voltar"
                  />
                  <q-btn
                    unelevated
                    rounded
                    color="red-9"
                    @click="validateForm"
                    label="Concluir"
                  />
                </div>
              </div>
            </q-toolbar>
          </q-footer>
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
  import DateTimePicker from "@/components/DateTimePicker";
import AttendanceClock from "@/components/generatedOsForm/AttendanceClock.vue";
import SelectCheckbox from "@/components/SelectCheckbox";
import { generateNextTenDays } from "@/utils/DateSchedules";
import moment from "moment";
import { useQuasar } from "quasar";
import { onMounted, reactive, ref } from "vue";
import {
  OS_MANUTENCAO as IMEDIATAR_OS_MANUTENCAO,
} from "@/utils/constants/typeOs/immediateOs";
import { VISITA_TECNICA_2 } from "@/utils/constants/typeOs/generateOs";
import { computed } from "vue";

  export default {
    name: "MeshForm",
    components: {
      SelectCheckbox,
      DateTimePicker,
      AttendanceClock,
    },
    props: {
      listWriteOffCode: Array,
      listTypeOS: Array,
      optionsWriteOffCode: Array,
      optionsTypeOS: Array,
      optionsTypeOSByClassification: Array,
      optionsActionOs: Array,
      optionsStateEquipaments: Array,
      itemOsContract: Object,
      typeOs: String,
      listGenerateOs: Array,
    },
    emits: ["saveSchemaRequest", "removeEdit", 'onTypeOsAttendance'],

    setup(props, { emit }) {
      moment.locale("pt-br");

      const $q = useQuasar();

      let panel = ref("tab-1");
      let progressBar = ref(0.5);
      const VALUE_MAX_BAR_PROGRESS = 1;

      let requestData = reactive(props.itemOsContract);
      let tabindex = ref(1);

      const isEnableScheduling = ["9", "4", '14',];

      const numericalTypeOs = Number(props.typeOs);

      const eqtoStreamingAmount = [
        {
          id: 1,
          text: "1",
          value: 1,
        },
        {
          id: 2,
          text: "2",
          value: 2,
        },
        {
          id: 3,
          text: "3",
          value: 3,
        },
      ];

      const datesHoursAvailableForSelection = reactive({
        date: [],
        hour: [
          {
            id: 1,
            text: "08h - 12h",
            value: "08 - 12",
          },
          {
            id: 2,
            text: "12h - 15h",
            value: "12 - 15",
          },
          {
            id: 3,
            text: "15h - 18h",
            value: "15 - 18",
          },
        ],
      });

      const writeOffCodeForTechnicalVisit = computed(() => {
        return props.listWriteOffCode.filter(
          (item) => item.value === 530
        );
      });

      let schemaRequest = reactive({
        object_id: "",
        osNumber: "",
        typeOS: "",
        statusOS: 1,
        writeOffCode: "",
        observation: "",
        check: false,
        replicate: false,
        source: "",
        action: 1,
        state: 1,
        equipamentNumberInstall: "",
        equipamentNumberDesinstall: "",
        cardNumberInstaled: "",
        cardNumberUninstalled: "",
      });
      const formtab1 = ref(null);
      const formtab2 = ref(null);

      const listTypeOS = ref([]);
      const attendanceOptions = ref(props.optionsTypeOS);
      const listWriteOffCode = ref([]);

      const optionsItens = reactive({
        optionsTypeOS: props.optionsTypeOS,
        optionsWriteOffCode: listWriteOffCode,
      });

      const schedulingTypes = {
        'schedule' : "Realizar agendamento",
        'default' : "Abertura imediata",
      };

      function setTypeOsByServiceOption() {
        if (props.optionsTypeOS.length == 1) {
          requestData.typeOS = props.optionsTypeOS[0];
        }
      }

      function filterTypeOsByName(val, update, abort){
         update(() => {
          const needle = val.toLowerCase();
          attendanceOptions.value = props.optionsTypeOS.filter(
            (option) => option.text.toLowerCase().indexOf(needle) > -1
          );
        })
      }



      function getTypeOsByClassification(val, update) {
        let selectedOption = props.optionsActionOs.find(
          (option) => option.id_acao == requestData.action
        );

        update(() => {
          optionsItens.optionsTypeOS = props.listTypeOS.filter(
            (optionTypeOS) => {
              return (
                optionTypeOS.id_classificacao == selectedOption.id_classificacao
              );
            }
          );
        });
      };

      function populateClientRackForm(){
        requestData.movimentTerminal = 1;
        requestData.action = 3;
      };

      async function validateClientRackForm() {
        if (progressBar.value === VALUE_MAX_BAR_PROGRESS) {
          const isValid = await formtab2.value.validate();
          if (isValid) {
            if (numericalTypeOs !== VISITA_TECNICA_2) {
               populateClientRackForm();
            }
            await emitData();
          }
          return isValid;
        }
        return await formtab1.value.validate();
      }

      async function validateForm() {
        let isValid = false;
        let hasTwoTabs = props.typeOs == "1" || props.typeOs == "10";

        if (hasTwoTabs) {
         return await validateClientRackForm();
        } else {
          isValid = await formtab1.value.validate();

          if (isValid) {
            await emitData();
          }
        }
        return isValid;
      };

      function addDateSchedule() {
        datesHoursAvailableForSelection.date = generateNextTenDays();
      }

      function isShowProgessBar() {
        return panel.value != "tab-2" && (props.typeOs == "1" || props.typeOs == '10');
      }

      function _changeTab() {
        const VALUE_INCREMENT_ID_TAB = 1;
        const STRING_ID_TAB = "tab-";

        tabindex.value += VALUE_INCREMENT_ID_TAB;
        panel.value = STRING_ID_TAB + tabindex.value;

        return true;
      }

      async function addValueBarProgressAndAlterTab() {
        console.log("addValueBarProgressAndAlterTab", props.typeOs);

        const VALUE_ADD_PROGRESS = 0.5;

        if (
          progressBar.value != VALUE_MAX_BAR_PROGRESS &&
          (await validateForm())
        ) {
          console.log("validateForm", progressBar.value, );
          let validateIfChangeTab = _changeTab();

          if (validateIfChangeTab) {
            progressBar.value += VALUE_ADD_PROGRESS;
            console.log("progressBar.value", progressBar.value);
            console.log('panel.value', panel.value);
          }
        }
      };

      function openDialogEquipament(item, isInstall = true) {
        $q.dialog({
          title: "Confirme a numeração",
          message: item,
          cancel: true,
        })
          .onOk(() => {})
          .onCancel(() => {
            requestData.equipamentNumberUninstall = "";
          });
      };

      async function emitData() {
        emit("saveSchemaRequest", requestData);
      };

      function onAttendanceOsTypeChange(){
        if (requestData.typeOsForAttendance) {
          emit('onTypeOsAttendance', requestData.typeOsForAttendance);
        }
      }

      onMounted(() => {
        requestData.movimentscheduling = schedulingTypes['default'];
        setTypeOsByServiceOption();
        addDateSchedule();
      });

      return {
        panel,
        progressBar,
        schemaRequest,
        requestData,
        optionsItens,
        formtab1,
        formtab2,
        validateForm,
        datesHoursAvailableForSelection,
        addDateSchedule,
        getTypeOsByClassification,
        isEnableScheduling,
        eqtoStreamingAmount,
        openDialogEquipament,
        isShowProgessBar,
        addValueBarProgressAndAlterTab,
        populateClientRackForm,
        validateClientRackForm,
        schedulingTypes,
        IMEDIATAR_OS_MANUTENCAO,
        numericalTypeOs,
        VISITA_TECNICA_2,
        onAttendanceOsTypeChange,
        writeOffCodeForTechnicalVisit,
        filterTypeOsByName,
        attendanceOptions,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
